import {configureStore} from '@reduxjs/toolkit'
import themeReducer from '../modules/settings/slices/ThemeSlice'
import selectedModuleReducer from '../modules/settings/slices/SelectedModuleSlice'
import sessionReducer from './slices/SessionSlice'
import languageReducer from './slices/LanguageSlice'
import uiReducer from './slices/UISlice'
import {sessionMiddleware} from './middleware/SessionMiddleware'
import {setStoreRef} from "../utils/AxiosHelper";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    selectedModule: selectedModuleReducer,
    session: sessionReducer,
    language: languageReducer,
    ui: uiReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sessionMiddleware)
})

// Set the store reference for api interceptors
setStoreRef(store);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
